<template>
  <div class="home">
    <LoggedIn v-if="loggedIn" />
    <LoggedOut v-else />
  </div>
</template>

<script>
// @ is an alias to /src
import LoggedIn from "@/components/shop/purchase/loggedIn.vue";
import LoggedOut from "@/components/shop/purchase/loggedOut.vue";

export default {
  name: "Home",
  components: {
    LoggedIn,
    LoggedOut,
  },
  data() {
    return {
      loggedIn: true
    }
  },
  created() {
     document.title = "Avishkaar Shop";
     if(this.$cookies.get('userAccess') == null){
       this.loggedIn = false
      //  this.$cookies.set('userCart','[{"productCode":"FGMI-HD-0019","quantity":"1","type":"product"},{"productCode":"FGMI-HD-0001","quantity":"1","type":"product"}]')
     }  
     this.$cookies.remove("birthday");
  }
};
</script>
<style>
body {
      background: #F5F5F5;
}
</style>
